export default __webpack_public_path__ + "navigation-camera-pitch-near-maneuver-enabled-960-2e2e3a90e6677ef3c94356ce15be2378.webp";